<div class="h-screen flex flex-col bg-beigeLuna">
  <app-header></app-header>
  <div class="flex-1 overflow-hidden">
    <app-menu></app-menu>
  </div>
</div>

